export const getHijriDate = (date) => {
  try {
    return new Intl.DateTimeFormat('ar-SA-u-ca-islamic', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(new Date(date));
  } catch (error) {
    return '';
  }
};

export const getGregorianDate = (date) => {
  try {
    return new Intl.DateTimeFormat('ar-EG', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      calendar: 'gregory'
    }).format(new Date(date));
  } catch (error) {
    return '';
  }
};

export const formatBothDates = (date) => {
  const hijri = getHijriDate(date);
  const gregorian = getGregorianDate(date);
  return { hijri, gregorian };
};
